import { render, staticRenderFns } from "./PreviewTemplate.vue?vue&type=template&id=2c623b66&scoped=true"
import script from "./PreviewTemplate.vue?vue&type=script&lang=js"
export * from "./PreviewTemplate.vue?vue&type=script&lang=js"
import style0 from "./PreviewTemplate.vue?vue&type=style&index=0&id=2c623b66&prod&lang=scss&scoped=true"
import style1 from "./PreviewTemplate.vue?vue&type=style&index=1&id=2c623b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c623b66",
  null
  
)

export default component.exports